import { Component } from 'preact';

import Card from '../card/index';
import Loader from '../loader/index';
import Thermometer from '../thermometer/index';
import style from './style.scss';
import DataLine from './data-line';
import { getTemperatureColourInterpolator } from '../../utils/interpolators';
import { convertTemperature } from '../../utils/unit-converters';

/**
 * The TemperatureSummary component is displayed on the home page as part of the primary live
 * data view. It displays live temperature information.
 *
 * props:
 * - data: A data model object containing the data needed for the view
 * - temperatureUnit: The current temperature unit
 * - temperatureFormatter: A function for formatting temperature values for display purposes
 * - temperatureTrendFormatter: A function for formatting the temperature trend value for display purposes
 * - timeFormatter: A function for formatting timestamps for display purposes
 */

class TemperatureSummary extends Component {

	constructor(props) {
		super(props);

		this.temperatureInterpolator = getTemperatureColourInterpolator(true);
	}

	render(props) {

		const { data, temperatureUnit, temperatureFormatter, temperatureTrendFormatter, timeFormatter } = props;

		if (!data) {
			return (
				<Card>
					<Loader />
				</Card>
			);
		}

		const tempStyle = {
			borderBottomColor: this.temperatureInterpolator(data.currentTemperature, temperatureUnit)
		};

		let temperatureTrendArrow = null;

		if (data.temperatureTrend !== 0) {
			const arrow = data.temperatureTrend > 0 ? '\u2191' : '\u2193';
			temperatureTrendArrow = <span class={style.temperature_trend_arrow}>{ arrow }</span>;
		}

		return (
			<Card>
				<div class={style.temperature_main}>
					<div class={style.temperature_current} style={tempStyle}>
						{ temperatureFormatter(data.currentTemperature) }
						<span class={style.shrink_unit}>°{ temperatureUnit }</span>
					</div>
					<div>
						<span class={style.data_line}>

							<span class={style.temperature_trend}>

								{ temperatureTrendArrow }

								<span class={style.data_value}>
									{ (data.temperatureTrend >= 0 ? '+' : '') + temperatureTrendFormatter(data.temperatureTrend) }
									<span class={style.shrink_unit}>°{ temperatureUnit }/hr</span>
								</span>

							</span>

						</span>
					</div>
				</div>

				<div class={style.thermometer_wrapper}>

					<div class={style.thermometer}>
						<Thermometer currentValue={convertTemperature(data.currentTemperature, temperatureUnit)}
						             minValue={convertTemperature(data.lowTemperature, temperatureUnit)}
						             maxValue={convertTemperature(data.highTemperature, temperatureUnit)} />
					</div>

					<div class={style.temperature_extremes}>
						<div class={style.temperature_high}>
							<div>High</div>
							<div class={style.extreme_value}>
								<span>{ temperatureFormatter(data.highTemperature) }</span>
								<span class={style.shrink_unit}>°{ temperatureUnit }</span>
							</div>
							<div>{ timeFormatter(data.highTemperatureTime) }</div>
						</div>

						<div class={style.temperature_low}>
							<div>Low</div>
							<div class={style.extreme_value}>
								<span>{ temperatureFormatter(data.lowTemperature) }</span>
								<span class={style.shrink_unit}>°{ temperatureUnit }</span>
							</div>
							<div>{ timeFormatter(data.lowTemperatureTime) }</div>
						</div>
					</div>

				</div>

				<div class={style.humidity_dewpoint}>
					<DataLine label="Humidity" value={data.currentHumidity} unit="%" />
					<DataLine label="Dewpoint" value={temperatureFormatter(data.currentDewpoint)} unit={`°${temperatureUnit}`} />
				</div>
			</Card>
		);
	}

}

export default TemperatureSummary;


// WEBPACK FOOTER //
// ./components/live/temperature-summary.js